import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ClienteService } from 'src/app/services/cliente.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { EmailService } from 'src/app/services/email.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { LoginService } from 'src/app/services/login.service';
import {PRECIO_UNITARIO_BASICA, IVA, PRECIO_UNITARIO_BASICA_IVA, PRECIO_UNITARIO_AMPLIADA, PRECIO_UNITARIO_AMPLIADA_IVA} from './../../../../constants/constants';

@Component({
  selector: 'app-solicitud-centros',
  templateUrl: './solicitud-centros.component.html',
  styleUrls: ['./solicitud-centros.component.scss']
})
export class SolicitudCentrosComponent implements OnInit {
  contratistas:any = []
  userLog:any
  contratistaSeleccionado:any
  numCentros:any
  contratistaMail:any
  iva: number
  precioBasica: number
  precioBasicaIva: number
  precioAmpliada: number
  precioAmpliadaIva: number
  

  constructor(private loginService: LoginService, 
    private clienteService:ClienteService, 
    private facturaService:FacturacionService, 
    private apollo: Apollo,
    private emailService: EmailService) {

    this.userLog = loginService.getUserData()
    this.iva = IVA;
    this.precioBasica = PRECIO_UNITARIO_BASICA;
    this.precioBasicaIva = PRECIO_UNITARIO_BASICA_IVA;
    this.precioAmpliada = PRECIO_UNITARIO_AMPLIADA;
    this.precioAmpliadaIva = PRECIO_UNITARIO_AMPLIADA_IVA;
   }

  ngOnInit(): void {
    this.getContratistasByCliente()
  }
  getContratistasByCliente(): void {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getContratistasByCliente(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data)
        this.contratistas = data.cliente.contratistas


      }
      )
  }


  sendSolicitud(){
    if (this.userLog.cliente.xtensaBasica == true) {
      this.addFacturaBasica(this.userLog.cliente.id, this.contratistaSeleccionado.id, this.numCentros)
    }else{
      this.addFacturaAmpliada(this.userLog.cliente.id, this.contratistaSeleccionado.id, this.numCentros)
    }

    const templateSolicitud = `
                <!DOCTYPE html>
                <html>
                <head>
                <title></title>
                </head>

                <body>
                <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/ampliacion_d5bfa07702.png' style="width:500px; height:340px; display:block;
                margin:auto;">
                <div style="width:500px; margin:auto">
                <p>Estimado ${this.contratistaSeleccionado.contactoResponsable.mail}</p>
                <p>Su cliente ${this.userLog.cliente.nombreComercial} le solicita el registro en Xtensa de ${this.numCentros} nuevos centros Productores.</p>
                <p>Por favor a continuación, inicie sesión para el pago de las correspondientes licencias. </p>
                <a href="www.xtensa.es"><img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/AV_96b6ea682a.png' style="width:100px; height:63px; display:block;
                margin:auto;"></a>
                </div>
                <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/correo_Xtensaimagen_9ccf8dd0f3.png' style="width:500px; height:540px; display:block;
                margin:70px auto;">
                </body>
                </html>`;
                setTimeout(() => {
                  this.emailService.send(
                    this.contratistaSeleccionado.contactoResponsable.mail,
                    'Solicitud Ampliación de Centros',
                    templateSolicitud
                  );
                }, 500);

   
  }

  addFacturaBasica(idCliente: any, idContratista: any, numero: any) {
    const baseImponible = this.precioBasica * numero
    const importeIva = (baseImponible * this.iva) / 100
    const precioTotal = baseImponible + importeIva
    console.log(baseImponible, importeIva, precioTotal);
    
    this.apollo
      .mutate({
        mutation: this.facturaService.addFactura(),
        variables: {
          input: {
            data: {
              cliente: idCliente,
              contratista: idContratista,
              numeroLicencias: numero,
              concepto: "LICENCIA XTENSA ANUAL AMPLIADA",
              estado: "invitacion",
              precioUnitario: this.precioBasica,
              iva: this.iva,
              baseImponible: baseImponible,
              precioTotal: precioTotal,
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
            console.log('OK', data);
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }

  addFacturaAmpliada(idCliente: any, idContratista: any, numero: any) {
    const baseImponible = this.precioAmpliada * numero
    const importeIva = (baseImponible * this.iva) / 100
    const precioTotal = baseImponible + importeIva
    console.log(baseImponible, importeIva, precioTotal);
    
    this.apollo
      .mutate({
        mutation: this.facturaService.addFactura(),
        variables: {
          input: {
            data: {
              cliente: idCliente,
              contratista: idContratista,
              numeroLicencias: numero,
              concepto: "LICENCIA XTENSA ANUAL AMPLIADA",
              estado: "invitacion",
              precioUnitario: this.precioAmpliada,
              iva: this.iva,
              baseImponible: baseImponible,
              precioTotal: precioTotal,
            },
          },
        },
      })
      .subscribe(
        ({ data, errors }) => {
            console.log('OK', data);
        },
        (error) => {
          console.log('Error al lanzar la query', error);
        }
      );
  }


}
